import Splide from '@splidejs/splide';
// import stickybits from 'stickybits';

window.onload = () => {
  const perPage = 4;
  let breakpoints = {
    1230: {
      perPage: 3,
    },
    1000: {
      perPage: 2,
    },
    600: {
      perPage: 1,
    },
  };

  if (document.querySelector('.CmsHotJobsSlider')) {
    breakpoints = {
      1100: {
        perPage: 2,
        perMove: 2,
      },
      650: {
        perPage: 1,
        perMove: 1,
      },
    };

    const splideHotJobsCms = new Splide('.CmsHotJobsSlider', {
      type: 'slide',
      arrows: true,
      breakpoints,
      pagination: false,
      width: '100%',
      gap: 16,
      perPage: 3,
      perMove: 3,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
    });

    splideHotJobsCms.on('ready', () => {
      const jobsCarousel = document.getElementById('hot-jobs-carousel');
      const event = new CustomEvent('ready');
      jobsCarousel.dispatchEvent(event);
    });

    splideHotJobsCms.on('moved', () => {
      const payload = { index: splideHotJobsCms.index, perPage: splideHotJobsCms.options.perPage };
      const jobsCarousel = document.getElementById('hot-jobs-carousel');
      const event = new CustomEvent('visible', { detail: payload });
      jobsCarousel.dispatchEvent(event);
    });

    splideHotJobsCms.mount();
    window.cmsHotJobsSplide = splideHotJobsCms;
  }

  if (document.querySelector('.CmsReviewsSlider')) {
    breakpoints = {
      1100: {
        perPage: 2,
        perMove: 2,
      },
      650: {
        perPage: 1,
        perMove: 1,
      },
    };

    const splideReviewsCms = new Splide('.CmsReviewsSlider', {
      type: 'slide',
      arrows: true,
      breakpoints,
      pagination: false,
      width: '100%',
      gap: 16,
      perPage: 3,
      perMove: 3,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
    });

    splideReviewsCms.on('ready', () => {
      const reviewsCarousel = document.getElementById('reviews-carousel');
      const event = new CustomEvent('ready');
      reviewsCarousel.dispatchEvent(event);
    });

    splideReviewsCms.on('moved', () => {
      const payload = { index: splideReviewsCms.index, perPage: splideReviewsCms.options.perPage };
      const reviewsCarousel = document.getElementById('reviews-carousel');
      const event = new CustomEvent('visible', { detail: payload });
      reviewsCarousel.dispatchEvent(event);
    });

    splideReviewsCms.mount();
    window.cmsReviewsSplide = splideReviewsCms;
  }

  if (document.querySelector('.CmsCaseStudiesSlider')) {
    breakpoints = {
      1100: {
        perPage: 2,
        perMove: 2,
      },
      650: {
        perPage: 1,
        perMove: 1,
      },
    };

    const splideCaseStudiesCms = new Splide('.CmsCaseStudiesSlider', {
      type: 'slide',
      arrows: true,
      breakpoints,
      pagination: false,
      width: '100%',
      fixedWidth: '310px',
      gap: 16,
      perPage: 3,
      perMove: 3,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
    });

    splideCaseStudiesCms.on('ready', () => {
      const caseStudiesCarousel = document.getElementById('case-studies-carousel');
      const event = new CustomEvent('ready');
      caseStudiesCarousel.dispatchEvent(event);
    });

    splideCaseStudiesCms.on('moved', () => {
      const payload = { index: splideCaseStudiesCms.index, perPage: splideCaseStudiesCms.options.perPage };
      const caseStudiesCarousel = document.getElementById('case-studies-carousel');
      const event = new CustomEvent('visible', { detail: payload });
      caseStudiesCarousel.dispatchEvent(event);
    });

    splideCaseStudiesCms.mount();
    window.cmsCaseStudiesSplide = splideCaseStudiesCms;
  }

  if (document.querySelector('.CmsArticlesSlider')) {
    breakpoints = {
      1100: {
        perPage: 2,
        perMove: 2,
      },
      650: {
        perPage: 1,
        perMove: 1,
      },
    };

    const cmsArticlesSliders = document.querySelectorAll('.CmsArticlesSlider');
    if (cmsArticlesSliders !== null) {
      cmsArticlesSliders.forEach((element) => {
        const splideArticlesCms = new Splide(element, {
          type: 'slide',
          arrows: true,
          breakpoints,
          pagination: false,
          width: '100%',
          gap: 16,
          perPage: 2,
          perMove: 2,
          rewind: false,
          focus: 'left',
          trimSpace: 'move',
        });

        splideArticlesCms.on('ready', () => {
          const articlesCarousel = document.getElementById('articles-carousel');
          const event = new CustomEvent('ready');
          articlesCarousel.dispatchEvent(event);
        });

        splideArticlesCms.on('moved', () => {
          const payload = {index: splideArticlesCms.index, perPage: splideArticlesCms.options.perPage};
          const articlesCarousel = document.getElementById('articles-carousel');
          const event = new CustomEvent('visible', {detail: payload});
          articlesCarousel.dispatchEvent(event);
        });

        splideArticlesCms.mount();
        window.cmsArticlesSplide = splideArticlesCms;
      });
    }
  }

  if (document.querySelector('#splide.RelatedJobsSlider')) {
    const splide = new Splide('#splide.RelatedJobsSlider', {
      type: 'slide',
      arrows: true,
      breakpoints,
      fixedWidth: '310px',
      pagination: false,
      width: '100%',
      gap: 24,
      perPage,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
      omitEnd: true,
    });
    // Event to smooth dom rendering. No sudden resizes before component is mounted.
    splide.on('mount.after', () => {
      document.querySelector('.RelatedJobsSlider.hidden').classList.remove('hidden');
    });

    splide.mount();
  }

  if (document.querySelector('#splideEvents.RelatedEventsSlider')) {
    const splideEvents = new Splide('#splideEvents.RelatedEventsSlider', {
      type: 'slide',
      arrows: true,
      breakpoints,
      fixedWidth: '310px',
      pagination: false,
      width: '100%',
      gap: 24,
      perPage,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
      omitEnd: true,
    });

    // Event to smooth dom rendering. No sudden resizes before component is mounted.
    splideEvents.on('mount.after', () => {
      document.querySelector('.RelatedEventsSlider.hidden').classList.remove('hidden');
    });

    splideEvents.mount();
  }

  if (document.querySelector('#splideCaseStudies.RelatedCaseStudiesSlider')) {
    const caseStudiesBreakpoints = {
      700: {
        perPage: 1,
        fixedWidth: '90%',
      },
    };
    const splideCaseStudies = new Splide('#splideCaseStudies.RelatedCaseStudiesSlider', {
      type: 'slide',
      arrows: true,
      breakpoints: caseStudiesBreakpoints,
      fixedWidth: '48%',
      pagination: false,
      width: '100%',
      gap: 24,
      perPage,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
      omitEnd: true,
    });

    // Event to smooth dom rendering. No sudden resizes before component is mounted.
    splideCaseStudies.on('mount.after', () => {
      document.querySelector('.RelatedCaseStudiesSlider.hidden').classList.remove('hidden');
    });

    splideCaseStudies.mount();
  }

  if (document.querySelector('#splideReviews.RelatedReviewsSlider')) {
    const reviewsBreakpoints = {
      700: {
        perPage: 1,
        fixedWidth: '90%',
      },
    };
    const splideReviews = new Splide('#splideReviews.RelatedReviewsSlider', {
      type: 'slide',
      arrows: true,
      breakpoints: reviewsBreakpoints,
      fixedWidth: '310px',
      pagination: false,
      width: '100%',
      gap: 24,
      perPage,
      rewind: false,
      focus: 'left',
      trimSpace: 'move',
      omitEnd: true,
    });

    // Event to smooth dom rendering. No sudden resizes before component is mounted.
    splideReviews.on('mount.after', () => {
      document.querySelector('.RelatedReviewsSlider.hidden').classList.remove('hidden');
    });

    splideReviews.mount();
  }

  // If browser does not support position:sticky then stickybits will append parent element with js-stickybit-parent class

  // const sticky = document.querySelector('#sticky');
  //
  // if (sticky !== null) {
  //   stickybits(sticky);
  //
  //   if (document.querySelector('.js-stickybit-parent') !== null) {
  //     const height = document.querySelector('#sticky').offsetHeight;
  //     const width = document.querySelector('#sticky').offsetWidth;
  //     sticky.style.height = `${height}px`;
  //     sticky.style.maxWidth = `${width}px`;
  //   }
  // }

  return true;
};
